<!-- <mat-toolbar> -->
    
    <!-- <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex > -->

        <!-- <a href="https://1.envato.market/c/1257954/275988/4415?u=https%3A%2F%2Fthemeforest.net%2Fitem%2Ffuse-angularjs-material-design-admin-template%2F12931855"
           target="_blank" mat-button class="pink" fxFlex="0 0 auto" fxLayout="row"
           fxLayoutAlign="start center">
            <mat-icon class="s-16 mr-sm-4">shopping_cart</mat-icon>
            <span>Purchase FUSE (Angular 8+)</span>
        </a> -->

        <!-- <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <a mat-button routerLink="/documentation/getting-started/introduction">Documentation</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/changelog">Changelog</a>
        </div> [matTooltip]="Help"         
-->
<div
  fxLayoutAlign="end center"
  class="cursorHelp"
  id="add-contact-button"
  [@animate]="{ value: '*', params: { delay: '300ms', scale: '0.2' } }"
  *ngIf="isExist"
  (click)="onHelpClick()"
  [matMenuTriggerFor]="helpMenu"
  #menuTrigger="matMenuTrigger"

>
  <mat-icon
    role="img"
    id="help"
    class="mat-icon notranslate s-28 s-md-30 mat-accent material-icons"
    aria-hidden="true"
  >
    help
  </mat-icon>
</div>

<mat-menu #helpMenu="matMenu">
  <ng-container *ngIf="sousdocumentations$ | async as sousDocs">
    <button
      mat-menu-item
      *ngFor="let sousDoc of sousDocs"
      (click)="onSousDocumentationClick(sousDoc)"
    >
      {{ sousDoc.name }}
    </button>
  </ng-container>
</mat-menu>

<p-dialog 
  [(visible)]="isVisible" 
  [modal]="true" 
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
  [style]="{ width: '60vw', height: 'auto', padding: '0' }" 
  [draggable]="false" 
  [resizable]="false"
  [dismissableMask]="true" 
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
>
  <ng-container *ngIf="videoPath; else noVideo">
    <video 
      style="width: 100%; height:auto;" 
      controls 
      autoplay 
      muted
    >
      <source [src]="this.videoPath" type="video/mp4" />
      
    </video>
  </ng-container>
  <ng-template #noVideo>
    
  </ng-template>
</p-dialog>






<!-- </mat-toolbar> -->
